export function initFixedHeader(selector = "header-wrapper", fixedClass = "fixed-header") {
    const header = document.querySelector(selector);
//    console.log('here1');
    if (!header) {
       // console.warn(`Header not found: ${selector}`);
        return;
    }

    const headerHeight = header.offsetHeight;
    let isFixed = false; // track state
   // console.log(header);
    function onScroll() {
        const shouldBeFixed = window.scrollY > headerHeight;

        if (shouldBeFixed && !isFixed) {
            header.classList.add(fixedClass);
            isFixed = true;
        } else if (!shouldBeFixed && isFixed) {
            header.classList.remove(fixedClass);
            isFixed = false;
        }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
}